import * as qs from 'qs';
import { PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { AsyncPaymentResult } from '../../types/AsyncPaymentResult';
import { createExpectedError } from '../expectedError';
import { win } from '../../../utils/win';

type Size = {
  width: number;
  height: number;
};

export const PaymentPopupSize: {
  [paymentMethod in PaymentMethod]?: Size;
} = {
  [PaymentMethod.PayPal]: { width: 450, height: 608 },
};
export const defaultPaymentPopupSize: Size = { height: 1080, width: 800 };

export const getPaymentPopupSize = (paymentMethod: PaymentMethod): Size =>
  PaymentPopupSize[paymentMethod] || defaultPaymentPopupSize;

export const paymentFinishMessage = 'finish';
export const popupRedirectMessage = 'redirectFromWidget';
export const popupPingMessage = 'pingFromWidget';

export interface PostMessageFromPopup extends MessageEvent {
  data:
    | {
        type: typeof paymentFinishMessage;
        payload: string;
      }
    | any;
}

export const parseAsyncPaymentResultStr = (
  resultStr: string
): AsyncPaymentResult => {
  try {
    const result: AsyncPaymentResult = qs.parse(
      resultStr
    ) as unknown as AsyncPaymentResult;

    return {
      status: result.status,
      failureCode: result.failureCode,
      returnUrl: result.returnUrl,
    };
  } catch (error) {
    throw createExpectedError({
      errorMessage: 'Error when parsing payment finish response from popup',
      errorData: error,
    });
  }
};

export const parseReturnUrlQueryParams = (
  returnUrl: string
): Omit<AsyncPaymentResult, 'returnUrl'> | undefined => {
  try {
    const result: Omit<AsyncPaymentResult, 'returnUrl'> = qs.parse(
      returnUrl.slice(returnUrl.indexOf('?') + 1)
    ) as unknown as Omit<AsyncPaymentResult, 'returnUrl'>;

    return {
      status: result.status,
      failureCode: result.failureCode,
    };
  } catch (error) {
    return;
  }
};

export const windowFeatures = ({
  height,
  width,
}: {
  width: number;
  height: number;
}) => {
  const { height: screenHeight, width: screenWidth } = win?.screen;

  const top = screenHeight ? Math.max(0, screenHeight / 2 - height / 2) : 0;
  const left = screenWidth ? Math.max(0, screenWidth / 2 - width / 2) : 0;

  return `location=yes,height=${height},width=${width},scrollbars=yes,status=yes,top=${top},left=${left}`;
};
